/**
 * share-button — 檔名處理（**純函數**；Node 可直接 import → `scripts/ui-smoke.mjs` 真測）
 *
 * 為何要：分享 mp3 時要一個**跨平台安全**嘅檔名 —— Android／iOS／WhatsApp 都唔食
 *   `/ \ : * ? " < > |`，空名／超長名亦會出事。
 */
export function shareFilename(title: string, ext = 'mp3'): string {
  const clean = (title || '')
    .replace(/[\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 60);
  const suffix = ext.replace(/^\./, '').trim() || 'mp3';
  return `${clean || 'song'}.${suffix}`;
}
